import { Skeleton } from '@mui/material';
import { Box } from 'shared/mui/Box';

export function GatewayRulesFormSkeletonHead(): JSX.Element {
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 3, width: '100%', marginBottom: '24px' }}
    >
      <Skeleton height={40} sx={{ flex: 1 }} variant="rounded" />
      <Skeleton height={40} sx={{ flex: 1 }} variant="rounded" />
      <Skeleton height={40} variant="rounded" width={115} />
    </Box>
  );
}
